export default __webpack_public_path__ + "static/media/colors-2048w.21ecb9d3.png";